import { render, staticRenderFns } from "./LoaderForRelatedProducts.vue?vue&type=template&id=662149c7&"
import script from "./LoaderForRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./LoaderForRelatedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports